import {React,useEffect} from 'react'
import Topbar from '../../components/topbar/Topbar'
import './Error.css'
import { Link,useNavigate } from 'react-router-dom'

export default function Error() {
    const navigate = useNavigate();
    
    useEffect(() => {
      if(!window.localStorage.getItem('currentUID')){
          navigate('/login');
      }
      window.document.title='SocialHub - Opps Error!';
    }, [])
    
    return (
        <>
            <Topbar />
            <div className='errorpage'>
                <div className="error">
                    <h2>This page is not available</h2>
                    <Link to={'/'} style={{'width':'100%'}}><button className='rightShareBtn'>Go Back</button></Link>
                </div>
            </div>
        </>
    )
}